<section class="jb-grid one-up gr-unset grid-offset-l">
  <form
    [formGroup]="mainForm"
    #formRef
    (ngSubmit)="submit()"
    #templateFormReference="ngForm"
    *ngIf="!(isSubmitted$ | async)"
  >
    <dot-form-field-wrapper
      class="mb5"
      [title]="mainContent.contactInfo.h3Title"
      ><jb-form-field-container type="primary" class="mb3">
        <jb-input-label>{{
          mainContent.contactInfo.fullName.label
        }}</jb-input-label>
        <input jbInput type="text" formControlName="fullName" />
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && fullName.errors?.required
          "
        >
          {{ mainContent.contactInfo.fullName.validationLabels.required }}
        </jb-error>
      </jb-form-field-container>
      <jb-form-field-container type="primary">
        <jb-input-label>{{
          mainContent.contactInfo.email.label
        }}</jb-input-label>
        <input jbInput formControlName="email" type="email" />
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && email.errors?.required
          "
        >
          {{ mainContent.contactInfo.email.validationLabels.required }}
        </jb-error>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && email.errors?.emailInvalid
          "
        >
          {{ mainContent.contactInfo.email.validationLabels.invalid }}
        </jb-error>
      </jb-form-field-container></dot-form-field-wrapper
    >
    <dot-form-field-wrapper [title]="mainContent.help.h3Title">
      <jb-form-field-container class="mb3">
        <jb-select
          [placeholder]="mainContent.help.topic.label"
          formControlName="topic"
        >
          <jb-select-option
            *ngFor="let item of mainContent.help.topic.options"
            [name]="item.label"
            [value]="item.value"
          ></jb-select-option>
        </jb-select>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && topic.errors?.required
          "
        >
          {{ mainContent.help.topic.validationLabels.required }}
        </jb-error>
      </jb-form-field-container>
      <jb-form-field-container class="mb3">
        <jb-input-label>{{ mainContent.help.comments.label }}</jb-input-label>
        <textarea jbTextArea formControlName="comments"></textarea>
        <span class="dib lh-title pv2 pl3 charcoal f6">{{
          mainContent.help.comments.description
        }}</span>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && comments.errors?.required
          "
        >
          {{ mainContent.help.comments.validationLabels.required }}
        </jb-error>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && comments.errors?.minlength
          "
        >
          150 characters minimum.
        </jb-error>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted && comments.errors?.maxlength
          "
        >
          1500 characters maximum.
        </jb-error>
      </jb-form-field-container>
      <jb-form-field-container type="primary" class="mb3">
        <jb-input-label>{{
          mainContent.help.confirmationCode.label
        }}</jb-input-label>
        <input
          jbInput
          formControlName="confirmationCode"
          type="text"
          maxlength="6"
        />
        <span class="dib lh-title pv2 pl3 charcoal f6">{{
          mainContent.help.confirmationCode.description
        }}</span>
        <jb-error
          [showErrorIf]="
            templateFormReference.submitted &&
            confirmationCode.errors?.minlength
          "
        >
          {{ mainContent.help.confirmationCode.validationLabels.invalid }}
        </jb-error>
      </jb-form-field-container>

      <jb-checkbox
        formControlName="urgency"
        name="urgency"
        [checked]="mainContent.help.urgency?.isDefault === 'true' || false"
      >
        <span class="charcoal">{{ mainContent.help.urgency.label }}</span>
      </jb-checkbox>

      <button
        jbButton
        type="submit"
        theme="ctaPrimary"
        [isPaired]="false"
        class="w-100-important mt5"
        [isLoading]="submissionInProgress$ | async"
        [disabled]="submissionInProgress$ | async"
      >
        {{ mainContent.help.submitCTA.label }}
      </button>
    </dot-form-field-wrapper>
  </form>
</section>

<section
  class="jb-grid one-up gr-unset grid-offset-l"
  *ngIf="submissionSucceeded$ | async"
>
  <h3 class="w-100">{{ success.title }}</h3>
  <p class="col-10-m col-10-l lh-copy">{{ success.content }}</p>
</section>

<section
  class="jb-grid one-up gr-unset grid-offset-l"
  *ngIf="submissionFailed$ | async"
>
  <h3 class="w-100">{{ failure.title }}</h3>
  <p class="col-10-m col-10-l lh-copy">{{ failure.content }}</p>
</section>
